import React from 'react';
import CreditReportsHeader from './CreditReportsHeader';
import CreditReportsContent from './CreditReportsContent';

const CreditReports = () => {
    return (
        <>
            <CreditReportsHeader />
            <CreditReportsContent />
        </>
    );
};

export default CreditReports;
